import styled from "styled-components";
import { motion } from "motion/react";
import { Label } from "./components/label";
import { Input } from "./components/input";
import { PopoverContent } from "./components/popover";
import { Slider } from "./components/slider";

export const MonthButton = styled.button<{period: boolean}> `
display: flex;
height: 37.143px; 
padding: 8.714px 16.339px 8.429px 16.571px;
justify-content: center; 
align-items: center; 
border-radius: 19174000px; 
border: 0.571px solid #D1D5DB; 
font-weight: ${({period}) => ( period ? "600" : "400")};
color: ${({period}) => ( period ? "#fff" : "rgb(55, 65, 81")};
background: ${({period}) => ( period ? "#008e9f" : "#fff")};
`;

//Layout
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    padding-bottom: 112px;
    @media (min-width: 768px) {
        padding: 40px;
        padding-bottom: 48px;
    }
`;

export const CalculatorContainer = styled.div<{ isEligible: boolean }>`
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    @media (min-width: 768px) {
        gap: ${({ isEligible }) => (isEligible ? "16px" : "24px")};
    }
`;

//Shared white card
export const WhiteCard = styled.div`
    background-color: var(--color-white);
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(229, 231, 235, 0.6);
    overflow: hidden;
`;

//Confirmation message
export const ConfirmationOuter = styled(motion.div)`
    right: 0;
    z-index: 100;
    display: flex;
    justify-content: center;
    padding-top: 16px;
`;

export const ConfirmationBox = styled(motion.div)`
    background-color: #F0FDF4;
    border: 1px solid #479376;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
    max-width: 900px;
    margin: 0 16px 16px;
`;

export const ConfirmationIconWrap = styled.div`
    flex-shrink: 0;
`;

export const ConfirmationContent = styled.div`
    flex: 1;
`;

export const ConfirmationTitle = styled.p`
    color: var(--color-green);
    font-weight: var(--font-weight-demibold);
    font-size: 16px;
    margin-bottom: 0px;
`;

export const ConfirmationText = styled.p`
    color: rgba(71, 147, 118, 0.8);
    font-size: 14px;
    margin-top: 2px;
    margin-bottom: 0px;
`;

//Salary card
export const SalaryCard = styled(WhiteCard)<{ collapsed: boolean }>`
    transition: all 0.3s;
    ${({ collapsed }) => collapsed && `
        box-shadow: none;
        border: 1px solid #E5E7EB;
    `}
`;

export const CollapsedButton = styled.button`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    margin-bottom: 0px;
    cursor: pointer;
    border-radius: 16px;
    transition: background-color 0.2s;
    &:hover {
        background-color: #F9FAFB;
    }
`;

export const CollapsedLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const CollapsedTextGroup = styled.div`
    text-align: left;
`;

export const CollapsedLabel = styled.p`
    font-weight: var(--font-weight-demibold);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #9CA3AF;
    margin-bottom: 0px;
    font-size: 12px;
`;

export const CollapsedValue = styled.p`
    font-weight: var(--font-weight-demibold);
    margin-bottom: 0px;
    color: #111827;
    font-size: 16px;
`;

export const EditBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: var(--font-weight-medium);
    color: var(--color-petrol);
    background-color: #F0FDFA;
    padding: 6px 12px;
    border-radius: 9999px;
    transition: all 0.2s;
    ${CollapsedButton}:hover & {
        background-color: var(--color-petrol);
        color: var(--color-white);
    }
`;

export const ExpandedContent = styled.div`
    padding: 20px;
    @media (min-width: 768px) {
        padding: 24px;
    }
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FieldLabel = styled(Label)`
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #374151;
    font-size: 14px;
    font-weight: var(--font-weight-demibold);
`;

export const BlockLabel = styled(Label)`
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #374151;
    font-size: 14px;
    font-weight: var(--font-weight-demibold);
`;

export const SmallLabel = styled(Label)`
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #374151;
    font-size: 11px;
    font-weight: var(--font-weight-demibold);
`;

export const InfoTriggerButton = styled.button`
    color: #9CA3AF;
    padding: 4px;
    cursor: pointer;
    transition: color 0.2s;
    background: none;
    border: none;
    &:hover {
        color: var(--color-petrol);
    }
`;

export const InfoTriggerButtonLight = styled.button`
    color: rgba(255, 255, 255, 0.6);
    padding: 4px;
    cursor: pointer;
    transition: color 0.2s;
    background: none;
    border: none;
    &:hover {
        color: var(--color-white);
    }
`;

export const InfoPopoverContent = styled(PopoverContent)`
    width: 288px;
    padding: 16px;
    font-size: 14px;
    border-radius: 12px;
`;

export const InfoPopoverContentWide = styled(PopoverContent)`
    width: 320px;
    padding: 16px;
    font-size: 14px;
    border-radius: 12px;
`;

export const PopoverText = styled.p`
    color: #6B7280;
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 0px;
`;

export const InputWrap = styled.div`
    position: relative;
`;

export const CurrencyPrefix = styled.span`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #9CA3AF;
    font-size: 14px;
    font-weight: var(--font-weight-medium);
`;

export const SalaryInput = styled(Input)<{ hasError: boolean }>`
    height: 48px;
    padding-left: 40px;
    padding-right: 16px;
    font-size: 16px;
    border-radius: 12px;
    background-color: var(--color-white);
    transition: all 0.2s;
    border-color: ${({ hasError }) => (hasError ? "#FCA5A5" : "#D1D5DB")};
    &:hover {
        border-color: ${({ hasError }) => (hasError ? "#FCA5A5" : "rgba(0, 142, 159, 0.4)")};
    }
    &:focus-visible {
        border-color: var(--color-petrol);
        box-shadow: 0 0 0 2px rgba(0, 142, 159, 0.15);
    }
`;

export const ErrorBanner = styled(motion.div)`
    font-size: 12px;
    color: #DC2626;
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #FEF2F2;
    padding: 8px 12px;
    border-radius: 8px;
`;

//Main calculator interface
export const ResultsSection = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media (min-width: 768px) {
        gap: 16px;
    }
`;

export const MainGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
        gap: 16px;
    }
`;

export const ControlsCard = styled(WhiteCard)`
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (min-width: 768px) {
        padding: 24px;
    }
`;

export const PeriodGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const MonthButtonRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const SliderGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SliderHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
`;

export const SliderValueWrap = styled.div`
    text-align: right;
    line-height: 1;
`;

export const SliderValue = styled.span`
    font-size: 22px;
    font-weight: var(--font-weight-bold);
    color: var(--color-petrol);
`;

export const SliderUnit = styled.span`
    font-size: 14px;
    color: #6B7280;
    margin-left: 4px;
`;

export const StyledSlider = styled(Slider)`
    margin: 12px 0;
`;

export const SliderMetaRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: #9CA3AF;
    font-weight: var(--font-weight-medium);
    margin-top: 18px;
`;

export const BadgeTitle = styled.p`
    font-size: 12px;
    font-weight: var(--font-weight-demibold);
    margin-bottom: 0px;
    @media (min-width: 768px) {
        font-size: 14px;
    }
`;

export const BadgeText = styled.p`
    font-size: 11px;
    opacity: 0.8;
    margin-top: 2px;
    margin-bottom: 0px;
    @media (min-width: 768px) {
        font-size: 12px;
    }
`;

export const BadgeLink = styled.a`
    text-decoration: underline;
    color: inherit;
    margin-bottom: 0px;
`;

export const RecommendedBadge = styled(motion.div)`
    background-color: #F0FDF4;
    color: var(--color-green);
    border-radius: 12px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 16px;
    padding: 12px;
    border: 1px solid rgba(71, 147, 118, 0.15);
`;

export const InfoBadge = styled(motion.div)`
    background-color: #F0FDFA;
    color: var(--color-petrol);
    border-radius: 12px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 16px;
    padding: 12px;
    border: 1px solid rgba(0, 142, 159, 0.1);
`;

export const HighlightText = styled.strong`
    color: #006B78;
`;

export const ChooseLink = styled.span`
    color: var(--color-orange);
    text-decoration: underline;
    font-size: 12px;
    font-weight: var(--font-weight-bold);
    transition: color 0.2s;
`;

export const PulseIconWrap = styled(motion.span)`
    display: inline-block;
`;

export const RecommendCTA = styled(motion.button)`
    border-radius: 14px;
    border: 0.571px solid rgba(0, 142, 159, 0.20);
    background: #F0FDFA;
    width: 100%;
    height: 40.643px;
    margin-top: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
    &:hover ${ChooseLink} {
        color: #C4612A;
    }
`;

//Results card
export const ResultsCard = styled(WhiteCard)`
    display: flex;
    flex-direction: column;
`;

export const ResultsHeader = styled.div`
    background: linear-gradient(135deg, var(--color-petrol) 0%, #007080 100%);
    padding: 20px;
    text-align: center;
    position: relative;
    @media (min-width: 768px) {
        padding: 24px;
    }
`;

export const ResultsHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const ResultsHeaderLabel = styled.span`
    color: rgba(255, 255, 255, 0.8);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-size: 14px;
    font-weight: var(--font-weight-demibold);
`;

export const ResultsAmountWrap = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ResultsAmount = styled.span`
    color: var(--color-white);
    letter-spacing: -0.02em;
    line-height: 1;
    font-size: 48px;
    font-weight: var(--font-weight-bold);
    @media (min-width: 768px) {
        font-size: 56px;
    }
`;

export const ResultsAmountUnit = styled.span`
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    margin-top: 4px;
`;

export const ExceedsTooltip = styled.div`
    display: none;
    position: absolute;
    right: 0;
    top: 28px;
    width: 240px;
    background-color: var(--color-white);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 12px;
    font-size: 12px;
    text-align: left;
    z-index: 20;
    border: 1px solid #E5E7EB;
`;

export const ExceedsLimitWrap = styled.div`
    position: absolute;
    top: 16px;
    right: 16px;
    &:hover ${ExceedsTooltip} {
        display: block;
    }
`;

export const TooltipTitle = styled.p`
    color: #D97706;
    font-weight: var(--font-weight-demibold);
    margin-bottom: 4px;
`;

export const ChartArea = styled.div`
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (min-width: 768px) {
        padding: 24px;
    }
`;

//Visual breakdown
export const BreakdownWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
    margin-bottom: 16px;
`;

export const BarLabelsRow = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #6B7280;
    padding: 0 2px;
`;

export const BarTrack = styled.div`
    height: 12px;
    width: 100%;
    background-color: #F1F5F9;
    border-radius: 9999px;
    overflow: hidden;
    display: flex;
    position: relative;
`;

export const BarAllowance = styled(motion.div)`
    height: 100%;
    background-color: #CBD5E1;
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
`;

export const BarInsurance = styled(motion.div)`
    height: 100%;
    background-color: var(--color-petrol);
`;

export const BarMarker = styled.div`
    position: absolute;
    left: 90%;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: rgba(0, 142, 159, 0.3);
`;

export const LegendRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 4px;
    font-size: 12px;
    justify-content: center;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const LegendDot = styled.div<{ color: string }>`
    width: 10px;
    height: 10px;
    border-radius: 9999px;
    background-color: ${({ color }) => color};
`;

export const LegendText = styled.span`
    color: #4B5563;
`;

//CTA card
export const CtaCard = styled(WhiteCard)``;

export const CtaTop = styled.div`
    padding: 20px 20px 16px;
`;

export const CtaHeadingRow = styled.div`
    text-align: center;
    margin-bottom: 12px;
`;

export const CtaSubtitle = styled.p`
    color: #6B7280;
    font-size: 15px;
    margin-bottom: 0px;
`;

export const CtaRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;
    @media (min-width: 768px) {
        gap: 32px;
    }
`;

export const PriceWrap = styled.div`
    text-align: center;
    @media (min-width: 768px) {
        text-align: left;
    }
`;

export const PriceValue = styled.p`
    color: var(--color-petrol);
    font-size: 32px;
    line-height: 1;
    font-weight: var(--font-weight-bold);
    margin-bottom: 0px;
`;

export const PriceUnit = styled.span`
    color: #9CA3AF;
    font-size: 1rem;
    font-weight: var(--font-weight-regular);
    margin-left: 4px;
`;

export const NextButton = styled.button`
    font-weight: var(--font-weight-demibold);
    font-size: 14px;
`;

export const Disclaimer = styled.p`
    font-size: 12px;
    color: #9CA3AF;
    text-align: center;
    margin-top: 12px;
    margin-bottom: 0px;
`;

//Below threshold state
export const BelowThresholdCard = styled(WhiteCard)``;

export const BelowThresholdInner = styled.div`
    padding: 25px 20px;
`;

export const BelowHeading = styled.h2`
    color: #111827;
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    margin-bottom: 8px;
`;

export const BelowSubtitle = styled.p`
    color: var(--color-coal);
    max-width: 100%;
    line-height: 1.6;
    font-size: 15px;
    margin-bottom: 16px;
`;

export const BelowInfoLine = styled.p`
    font-size: 15px;
    margin-bottom: 4px;
`;

export const BelowInfoLineSpaced = styled.p`
    font-size: 15px;
    margin-bottom: 16px;
`;

export const BelowBenefitsWrap = styled.div`
    max-width: 32rem;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const BelowBenefitsTitle = styled.p`
    color: #111827;
    font-weight: var(--font-weight-demibold);
    margin-bottom: 0px;
    font-size: 15px;
`;

export const BelowBenefitsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #6B7280;
    padding-left: 0px;
`;

export const BelowBenefitItem = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    list-style: none;
`;

export const BelowBullet = styled.span`
    color: var(--color-orange);
    margin-top: 2px;
`;

export const BelowBenefitText = styled.span`
    font-size: 15px;
    color: var(--color-coal);
`;
